import { useCallback } from 'react';
import isNumber from 'lodash/isNumber';

import { useReactNodeView } from '@lyearn/lygo-core';

import { selectionType, setSelection } from '../utils';

const useSetSelection = () => {
  const { view, getPos } = useReactNodeView();

  const selectCurrentNode = useCallback(() => {
    const nodePos = typeof getPos === 'function' && getPos();
    if (isNumber(nodePos)) {
      setSelection(view!, selectionType.NODE, nodePos);
    }
  }, [getPos, view]);

  return { selectCurrentNode };
};

export default useSetSelection;
